import { render, staticRenderFns } from "./EditTalkgroup.vue?vue&type=template&id=45de9b2e&scoped=true"
import script from "./EditTalkgroup.vue?vue&type=script&lang=js"
export * from "./EditTalkgroup.vue?vue&type=script&lang=js"
import style0 from "./EditTalkgroup.vue?vue&type=style&index=0&id=45de9b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de9b2e",
  null
  
)

export default component.exports